import React, { useState, useEffect, useCallback } from "react";
import { Link, useLocation } from 'react-router-dom';
import axios from 'axios';
import Preloader from '../components/Preloader'

const ServiceSection = () => {
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const location = useLocation();
  const isHomePage = location.pathname === '/';


  const apiUrl = apiBaseUrl+`services?is_home=1`;
  const [data, setData] = useState([]);
  const [title, setTitle] = useState([]);
  const [loading, setLoading] = useState(true)

  const fetchPagedata = useCallback(async () => {
    let apiUrl = '';
    if (location.pathname === '/') {
        apiUrl = apiBaseUrl+`services?is_home=1`;
    } else {
        apiUrl = apiBaseUrl+`services`;
    }    
    return axios.get(apiUrl).then((res) => {
      setData(res.data);
    });
  },[]); 

  const fetchTitledata = useCallback(async () => {
    return axios.get(apiBaseUrl + "pagetitle").then((res) => {
      setTitle(res.data);
    });    
  },[]);

  useEffect(() => {
    const timer = setTimeout(() => {
      fetchPagedata();
      fetchTitledata();
      setLoading(false);
    }, 1000); // 1 seconds
    return () => clearTimeout(timer);
  }, [fetchPagedata]);

  const scrollToTop = () => {
    window.scrollTo({
        top: 0,
        behavior: 'smooth' // Optional, for smooth scrolling
  });
}; 


  return (
    <>
    { loading && ( <Preloader /> )}
    { isHomePage ?
    <section className="service-one">
        <div className="container tabs-box">
            <div className="sec-title text-center">
                <h6 className="sec-title__tagline">{ title?.service_heading }</h6>
                <h3 className="sec-title__title" dangerouslySetInnerHTML={{ __html: title?.service_sub_heading }}></h3>
            </div>
            <div className="tabs-content">
                <div className="tab fadeInUp animated active-tab" id="SEO">
                    <div className="row gutter-y-30">
                    {data.map((item, index) => {
                        return (
                            <div className="col-xl-3 col-md-6" key={index}>
                                <div className="service-one__item text-center">
                                    <div className="service-one__item__wrapper" data-bs-toggle="modal" data-bs-target={`#staticBackdrop-${item.id}`}>
                                        <div className="service-one__item__hover" style={{ backgroundImage: 'url(assets/images/resources/service-1-1-hover.png)' }}></div>
                                        <div className="service-one__item__icon" style={{ backgroundImage: 'url(assets/images/shapes/service-icon-bg.png)' }}>
                                            <img src={item.image} alt={item.name} />
                                        </div>
                                        <h3 className="service-one__item__title">
                                            {item.name}
                                        </h3>
                                        <p className="service-one__item__text">
                                            { item?.short_description.replace(/<\/?p>/gi, '')}... 
                                        </p>
                                            <Link className="service-one__item__rm" to="#"  data-bs-toggle="modal" data-bs-target={`#staticBackdrop-${item.id}`}>
                                            <svg viewBox="0 0 58 66" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M25.46 1.07519C27.646 -0.206291 30.354 -0.206292 32.54 1.07519L54.54 13.9717C56.6833 15.2281 58 17.5263 58 20.0106V45.9894C58 48.4737 56.6833 50.7719 54.54 52.0283L32.54 64.9248C30.354 66.2063 27.646 66.2063 25.46 64.9248L3.45996 52.0283C1.31675 50.7719 0 48.4737 0 45.9894V20.0106C0 17.5263 1.31675 15.2281 3.45996 13.9717L25.46 1.07519Z" />
                                            </svg>
                                            <i className="flaticon-up-right-arrow"></i>
                                        </Link>
                                        
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                        <div className="col-xl-12 col-md-12 mt-5 pt-5">
                            <div className="portfolio-one__item__btn text-center">
                                <Link className="growim-btn growim-btn--white" to="/services" onClick={scrollToTop}>
                                    <span className="growim-btn__text">View All Services</span>
                                    <span className="growim-btn__icon"><i className="flaticon-up-right-arrow"></i></span>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    :
    <section className="service-six">
        <div className="container">
            <div className="row gutter-y-30">
            {data.map((item, index) => {
                return(
                <div className="col-lg-4 col-md-6" key={ index }>
                    <div className="service-six__item text-center">
                        <div className="service-six__item__wrapper" data-bs-toggle="modal" data-bs-target={`#staticBackdrop-${item?.id}`}>
                            <div className="service-six__item__image">
                                <img src={ item?.image } alt={ item?.name } />
                            </div>
                            <div className="service-six__item__icon" style={{ backgroundImage: 'url(assets/images/shapes/service-6-icon-bg.png)' }}>
                                <img src={ item?.image } alt={ item?.name } />
                            </div>
                            <h3 className="service-six__item__title">
                                <Link to="#">{ item?.name }</Link>
                            </h3>
                            <p className="service-six__item__text">
                                { item?.short_description.replace(/<\/?p>/gi, '')}...
                            </p>
                            <Link className="service-six__item__rm" to="#" data-bs-toggle="modal" data-bs-target={`#staticBackdrop-${item?.id}`}>
                                <svg viewBox="0 0 58 66" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M25.46 1.07519C27.646 -0.206291 30.354 -0.206292 32.54 1.07519L54.54 13.9717C56.6833 15.2281 58 17.5263 58 20.0106V45.9894C58 48.4737 56.6833 50.7719 54.54 52.0283L32.54 64.9248C30.354 66.2063 27.646 66.2063 25.46 64.9248L3.45996 52.0283C1.31675 50.7719 0 48.4737 0 45.9894V20.0106C0 17.5263 1.31675 15.2281 3.45996 13.9717L25.46 1.07519Z"></path>
                                </svg>
                                <i className="flaticon-up-right-arrow"></i>
                            </Link>
                        </div>
                    </div>
                </div>
                )
            })}
            </div>
    </div>
    </section>
    }
    </>
  )
}

export default ServiceSection